// import React, { useEffect, useRef, useState } from "react";
// import { useAppSelector } from "../../redux/ReduxType";
// import {
//   MdCancel,
//   MdCategory,
//   MdCreate,
//   MdImage,
//   MdVideocam,
// } from "react-icons/md";
// import { PiFilmReelFill } from "react-icons/pi";
// import { ALLOWED_FILE_TYPES, MAX_FILE_SIZE } from "../../constant/constants";
// import { CgProfile } from "react-icons/cg";
// import { useForm } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
// import { postSchema } from "../../validation/post.schema";
// import { toast } from "sonner";
// import LoaderSpinner from "../molecules/Loader/Loader.spinner";
// import { uploadToCloudinary } from "../../utils/upload.cloudinary";
// import { useMakeRequest } from "../../hooks/useMakeRequest";
// import { POST_URL } from "../../constant/resource";
// import { useDispatch } from "react-redux";
// import { addPost, setPosts } from "../../redux/slice/post.slice";
// import Modal from "../modal/Modal";
// import { Link } from "react-router-dom";
// import { getUserLocation } from "../../hooks/getUserLocation";
// import { RxCross1 } from "react-icons/rx";
// import { postCategories } from "../../constant/post.category";

// interface ICreatePost {
//   userId?: string;
//   refetch?: () => void;
// }

// const CreatePost: React.FC<ICreatePost> = ({ userId, refetch }) => {
//   const [filePreview, setFilePreview] = useState<string | null>(null);
//   const [isVideo, setIsVideo] = useState(false);
//   const isDark = useAppSelector((state) => state.theme.isDark);
//   const User = useAppSelector((state) => state.user);
//   const [loading, setLoading] = useState(false);
//   const postImageRef = useRef<HTMLInputElement>(null);
//   const [postFile, setPostFile] = useState<File | null>(null);
//   const [fileError, setFileError] = useState<string | null>(null);
//   const makeRequest = useMakeRequest();
//   const dispatch = useDispatch();
//   const [showReel, setShowReel] = useState(false);
//   const [category, setCategory] = useState("");
//   const categoryRef = useRef<HTMLSelectElement | null>(null);
//   const [currentLocation, setCurrentLocation] = useState(null);
//   // const [createPost, {error}] = useMutation(CREATE_POST)

//   useEffect(() => {
//     const getLocation = async () => {
//       const locationData = await getUserLocation();
//       setCurrentLocation(locationData);
//     };
//     getLocation();
//   }, []);

//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm({
//     defaultValues: {
//       author: User._id,
//     },
//     resolver: yupResolver(postSchema),
//   });

//   const removeFile = () => {
//     setPostFile(null);
//     setFilePreview(null);
//     setIsVideo(false);
//     if (postImageRef.current) {
//       postImageRef.current.value = "";
//     }
//   };

//   // file handlers

//   const handleUpload = () => {
//     if (postImageRef.current) {
//       postImageRef.current.click();
//     }
//   };

//   const handleFile = (e: any) => {
//     setFileError(null);
//     if (e.target.files && e.target.files[0]) {
//       const file = e.target.files[0];

//       if (!ALLOWED_FILE_TYPES.includes(file.type)) {
//         setFileError(
//           "Invalid file type. Please upload an image (JPEG, PNG, GIF) or video (MP4, QuickTime)."
//         );
//         toast.error(
//           `Invalid file type. Please upload an image (JPEG, PNG, GIF) or video (MP4, QuickTime).`
//         );
//         return;
//       }

//       if (file.size > MAX_FILE_SIZE) {
//         setFileError(
//           `File is too large. Maximum size is ${
//             MAX_FILE_SIZE / (1024 * 1024)
//           } MB.`
//         );
//         toast.error(
//           `File is too large. Maximum size is ${
//             MAX_FILE_SIZE / (1024 * 1024)
//           } MB.`
//         );
//         return;
//       }

//       setPostFile(file);
//       const objectURL = URL.createObjectURL(file);
//       setFilePreview(objectURL);
//       setIsVideo(file.type.startsWith("video/"));
//     }
//   };

//   const onSuccess = (data: any) => {
//     toast.success("Post created");
//     if (refetch) refetch();
//   };

//   const onSubmit = async (data: any) => {
//     setLoading(true);
//     try {
//       let payload = {
//         ...data,
//         author: User._id,
//         location: currentLocation,
//         category: category || "General",
//       };
//       if (!payload.author) return toast.error("Pls try again");
//       if (postFile !== null) {
//         const fileURL = await uploadToCloudinary(postFile as File);
//         payload = { ...data, media: fileURL.url };
//       }
//       await makeRequest(
//         POST_URL + "/create",
//         "POST",
//         { ...payload },
//         onSuccess,
//         console.log,
//         () => {
//           setLoading(false);
//         }
//       );
//     } catch (error: any) {
//       toast.error(error.message || "Error creating post, try again");
//       console.log(error);
//     } finally {
//       setLoading(false);
//       setFilePreview(null);
//     }
//   };

//   // ------ modals -------

//   const handleCategory = () => {
//     categoryRef.current?.click();
//   };

//   const handleChange = (e: any) => {
//     setCategory(e.target.value);
//   };

//   const closeReel = () => {
//     setShowReel(false);
//   };

//   return (
//     <section
//       className={`rounded-lg overflow-auto text-sm ${
//         isDark ? "bg-darkBg text-darkText" : "bg-lightBg text-deepBg"
//       } p-5 mt-10`}
//     >
//       {filePreview && (
//         <div className="w-full h-[200px] overflow-hidden relative">
//           {isVideo ? (
//             <video
//               src={filePreview}
//               controls
//               className="object-cover rounded-lg shadow-lg h-[230px] w-full"
//             >
//               Your browser does not support the video tag.
//             </video>
//           ) : (
//             <img
//               src={filePreview}
//               alt="post media"
//               className="object-cover rounded-lg shadow-lg h-[230px] w-full"
//             />
//           )}
//           <button
//             onClick={removeFile}
//             className="absolute top-2 right-2 text-red-500 bg-black p-2 rounded-full"
//           >
//             <RxCross1 size={24} />
//           </button>
//         </div>
//       )}

//       {fileError && <div className="text-red-500 mt-2 mb-2">{fileError}</div>}
//       {/* post form */}
//       <form
//         className="flex items-center mt-5 justify-center gap-3"
//         onSubmit={handleSubmit(onSubmit)}
//       >
//         {/* <img className='w-10 h-10 object-cover rounded-full' src={} alt="" /> */}
//         {User?.avatar ? (
//           <img
//             src={User?.avatar}
//             alt="post media"
//             className="object-cover rounded-full shadow-lg h-[30px] w-[30px]"
//           />
//         ) : (
//           <CgProfile className="w-10 h-10" />
//         )}
//         <label className="p-3 bg-indigo-50 text-deepBg flex items-center gap-2 w-full rounded-full">
//           <input
//             {...register("content")}
//             type="text"
//             className="grow border-none outline-none bg-inherit"
//             placeholder="what's on your mind?"
//           />
//           <MdCreate className="text-indigo-400 text-lg" />
//         </label>
//         <button
//           className={`px-4 py-3 ${
//             isDark ? "bg-deepBg" : "bg-deepLight"
//           } rounded-full text-xs min-w-[100px]`}
//         >
//           {loading ? <LoaderSpinner color={"white"} /> : "Create Post"}
//         </button>
//       </form>
//       <div className="mt-4">
//         <div className={`px-5 w-full flex items-center justify-start gap-10`}>
//           <div className="flex items-center gap-2 cursor-pointer hover:bg-gray-100 hover:text-gray-600 px-2 py-[2px] rounded-full">
//             <MdImage className="text-blue-600 w-4 h-4" />
//             <input
//               onChange={(e) => {
//                 handleFile(e);
//               }}
//               className="hidden"
//               ref={postImageRef}
//               type="file"
//               name="postAvatar"
//               id="postAvatar"
//             />
//             <span onClick={handleUpload}>Image/Video</span>
//           </div>
//           <Link
//             to={`/live/${User?._id}`}
//             className="flex items-center gap-2 cursor-pointer hover:bg-gray-100 hover:text-gray-600 px-2 py-[2px] rounded-full"
//           >
//             <MdVideocam className="text-red-600 w-4 h-4" />
//             <span>Live</span>
//           </Link>

//           <button
//             onClick={handleCategory}
//             className="flex items-center gap-2 cursor-pointer hover:bg-gray-100 hover:text-gray-600 px-2 py-[2px] rounded-full"
//           >
//             <select
//               className="rounded-full p-[2px] text-slate-500"
//               ref={categoryRef}
//               name="category"
//               id="cayegory"
//               onChange={handleChange}
//             >
//               {postCategories?.map((eachcategory) => {
//                 return (
//                   <option value={eachcategory?.value}>
//                     {eachcategory?.label}
//                   </option>
//                 );
//               })}
//             </select>
//             <span>Category</span>
//           </button>
//         </div>
//       </div>

//       {/* Reel modal */}
//       <Modal showModal={showReel} toggler={closeReel}>
//         <div className="p-4 text-neutral-700">
//           <h1>Add reels here</h1>
//         </div>
//       </Modal>
//     </section>
//   );
// };

// export default CreatePost;

// ----- version 2 -----
import React, { useEffect, useRef, useState } from "react";
import { useAppSelector } from "../../redux/ReduxType";
import { MdImage, MdVideocam, MdOutlineCategory } from "react-icons/md"; // Updated icons
import { IoClose } from "react-icons/io5"; // Replaced RxCross1
import { CgProfile } from "react-icons/cg";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { postSchema } from "../../validation/post.schema";
import { toast } from "sonner";
import LoaderSpinner from "../molecules/Loader/Loader.spinner";
import { uploadToCloudinary } from "../../utils/upload.cloudinary";
import { useMakeRequest } from "../../hooks/useMakeRequest";
import { POST_URL } from "../../constant/resource";
import { useDispatch } from "react-redux";
// import { setPosts } from "../../redux/slice/post.slice";
import Modal from "../modal/Modal";
import { Link } from "react-router-dom";
import { getUserLocation } from "../../hooks/getUserLocation";
import { postCategories } from "../../constant/post.category";
import { ALLOWED_FILE_TYPES, MAX_FILE_SIZE } from "../../constant/constants";

interface ICreatePost {
  userId?: string;
  refetch?: () => void;
}

const CreatePost: React.FC<ICreatePost> = ({ userId, refetch }) => {
  const [filePreview, setFilePreview] = useState<string | null>(null);
  const [isVideo, setIsVideo] = useState(false);
  const isDark = useAppSelector((state) => state.theme.isDark);
  const User = useAppSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const postImageRef = useRef<HTMLInputElement>(null);
  const [postFile, setPostFile] = useState<File | null>(null);
  const [fileError, setFileError] = useState<string | null>(null);
  const makeRequest = useMakeRequest();
  const dispatch = useDispatch();
  const [showReel, setShowReel] = useState(false);
  const [category, setCategory] = useState("");
  const categoryRef = useRef<HTMLSelectElement | null>(null);
  const [currentLocation, setCurrentLocation] = useState<any>(null);

  useEffect(() => {
    const getLocation = async () => {
      const locationData = await getUserLocation();
      setCurrentLocation(locationData);
    };
    getLocation();
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: { author: User._id },
    resolver: yupResolver(postSchema),
  });

  const removeFile = () => {
    setPostFile(null);
    setFilePreview(null);
    setIsVideo(false);
    if (postImageRef.current) postImageRef.current.value = "";
  };

  const handleUpload = () => {
    if (postImageRef.current) postImageRef.current.click();
  };

  const handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFileError(null);
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      if (!ALLOWED_FILE_TYPES.includes(file.type)) {
        setFileError("Invalid file type. Only JPEG, PNG, GIF, MP4 allowed.");
        toast.error("Invalid file type. Only JPEG, PNG, GIF, MP4 allowed.");
        return;
      }
      if (file.size > MAX_FILE_SIZE) {
        setFileError(
          `File too large. Max ${MAX_FILE_SIZE / (1024 * 1024)} MB.`
        );
        toast.error(`File too large. Max ${MAX_FILE_SIZE / (1024 * 1024)} MB.`);
        return;
      }
      setPostFile(file);
      const objectURL = URL.createObjectURL(file);
      setFilePreview(objectURL);
      setIsVideo(file.type.startsWith("video/"));
    }
  };

  const onSuccess = (data: any) => {
    toast.success("Post created");
    // dispatch(setPosts(data?.data?.allPost));
    if (refetch) refetch();
  };

  const onSubmit = async (data: any) => {
    setLoading(true);
    try {
      let payload = {
        ...data,
        author: User._id,
        location: currentLocation,
        category: category || "General",
      };
      if (!payload.author) return toast.error("Please try again");
      if (postFile) {
        const fileURL = await uploadToCloudinary(postFile);
        payload = { ...payload, media: fileURL.url };
      }
      await makeRequest(
        POST_URL + "/create",
        "POST",
        payload,
        onSuccess,
        console.log,
        () => setLoading(false)
      );
    } catch (error: any) {
      toast.error(error.message || "Error creating post");
    } finally {
      setLoading(false);
      setFilePreview(null);
    }
  };

  const handleCategory = () => {
    categoryRef.current?.focus();
  };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setCategory(e.target.value);
  };

  const closeReel = () => {
    setShowReel(false);
  };

  return (
    <section
      className={`rounded-lg shadow-sm p-4 ${
        isDark ? "bg-darkBg text-white" : "bg-white text-gray-900"
      }`}
    >
      {/* File Preview */}
      {filePreview && (
        <div className="relative w-full h-48 mb-4 rounded-lg overflow-hidden">
          {isVideo ? (
            <video
              src={filePreview}
              controls
              className="w-full h-full object-cover"
            />
          ) : (
            <img
              src={filePreview}
              alt="Preview"
              className="w-full h-full object-cover"
            />
          )}
          <button
            onClick={removeFile}
            className="absolute top-2 right-2 p-1 bg-gray-900/60 text-white rounded-full hover:bg-gray-900 transition-colors duration-200"
            aria-label="Remove file"
          >
            <IoClose className="w-5 h-5" />
          </button>
        </div>
      )}
      {fileError && <p className="text-red-500 text-sm mb-4">{fileError}</p>}

      {/* Post Form */}
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <div className="flex items-center gap-3">
          {User?.avatar ? (
            <img
              src={User?.avatar}
              alt="Avatar"
              className="w-10 h-10 rounded-full object-cover shadow-sm"
            />
          ) : (
            <CgProfile className="w-10 h-10 text-gray-500 dark:text-gray-400" />
          )}
          <div
            className={`flex-1 flex items-center gap-2 px-4 py-2 rounded-md ${
              isDark
                ? "bg-gray-50 border-gray-600"
                : "bg-gray-300 border-gray-300"
            } border shadow-sm focus-within:ring-2 focus-within:ring-indigo-500`}
          >
            <input
              {...register("content")}
              type="text"
              className="flex-1 bg-transparent text-gray-500 outline-none text-sm placeholder-gray-500 dark:placeholder-gray-400"
              placeholder="What's on your mind?"
            />
          </div>
          <button
            type="submit"
            className="px-4 py-2 bg-indigo-600 text-white rounded-md text-sm font-medium hover:bg-indigo-700 shadow-sm hover:shadow-md transition-shadow duration-200 disabled:opacity-50"
            disabled={loading}
          >
            {loading ? <LoaderSpinner color="white" /> : "Post"}
          </button>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-4">
          <button
            type="button"
            onClick={handleUpload}
            className={`flex items-center gap-2 px-3 py-1 rounded-md text-sm ${
              isDark
                ? "text-gray-300 hover:bg-gray-700 hover:text-white"
                : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"
            } transition-colors duration-200`}
          >
            <MdImage className="w-5 h-5 text-blue-500" />
            <span>Image/Video</span>
            <input
              onChange={handleFile}
              className="hidden"
              ref={postImageRef}
              type="file"
              name="postAvatar"
              id="postAvatar"
            />
          </button>
          <Link
            to={`/live/${User?._id}`}
            className={`flex items-center gap-2 px-3 py-1 rounded-md text-sm ${
              isDark
                ? "text-gray-300 hover:bg-gray-700 hover:text-white"
                : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"
            } transition-colors duration-200`}
          >
            <MdVideocam className="w-5 h-5 text-red-500" />
            <span>Live</span>
          </Link>
          <div className="relative flex items-center gap-2">
            <button
              type="button"
              onClick={handleCategory}
              className={`flex items-center gap-2 px-3 py-1 rounded-md text-sm ${
                isDark
                  ? "text-gray-300 hover:bg-gray-700 hover:text-white"
                  : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"
              } transition-colors duration-200`}
            >
              <MdOutlineCategory className="w-5 h-5 text-gray-500" />
              <span>{category || "Category"}</span>
            </button>
            <select
              ref={categoryRef}
              name="category"
              id="category"
              value={category}
              onChange={handleChange}
              className={`absolute inset-0 opacity-0 cursor-pointer ${
                isDark ? "text-gray-300" : "text-gray-700"
              }`}
            >
              {postCategories.map((cat) => (
                <option key={cat.value} value={cat.value}>
                  {cat.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </form>

      {/* Reel Modal */}
      <Modal showModal={showReel} toggler={closeReel}>
        <div className="p-4 text-gray-700 dark:text-gray-300">
          <h1 className="text-lg font-medium">Add reels here</h1>
        </div>
      </Modal>
    </section>
  );
};

export default CreatePost;
